import styled from 'styled-components'

export const Flag = styled.div`
  cursor: pointer;
  width: calc(100% / 6 - 15px * 5 / 6);
  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    width: calc(100% / 3 - 15px * 2 / 3);
  }
`
